<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// 适配各种尺寸机型
(function (doc, win) {
  var docEl = doc.documentElement,
    resizeEvt = "orientationchange" in window ? "orientationchange" : "resize",
    recalc = function () {
      var clientWidth = docEl.clientWidth;
      if (!clientWidth) return;
      if (clientWidth >= 1080) {
        docEl.style.fontSize = "100px";
      } else {
        docEl.style.fontSize = 100 * (clientWidth / 1080) + "px";
      }
    };
  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener("DOMContentLoaded", recalc, false);
})(document, window);
export default {
  name: "App",
  mounted() {
    let clientWidth =
      document.documentElement.clientWidth || document.body.clientHeight;

    if (clientWidth > 768) {
      //当屏幕小于768时，设置Vuex里的数据为true
      window.location.href = "http://jsgtkj.com";
    }
  },
};
</script>

<style lang="less">
@import "./assets/reset.less";
.contentHtml {
  padding: 0 .3rem;
  p {
    font-size: .38rem;
    padding: .1rem 0;
    line-height: .8rem;
  }
  img {
    display: block;
    margin: 10px auto 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue